import type { EnumUnion } from '@dresscode-frontend/utility-types';

import { WorkerType } from '@/constants/workerType';

/**
 * 保有資格一覧のソート可能なカラム
 */
export const PeopleCertificationOrderBy = {
  ORGANIZATION_NAME: 'ORGANIZATION_NAME',
  PLACE_NAME: 'PLACE_NAME',
} as const satisfies Record<string, string>;

export type PeopleCertificationOrderBy = EnumUnion<
  typeof PeopleCertificationOrderBy
>;

/**
 * テーブルカラムの定義
 */
export const PeopleCertificationTableColumns = {
  person: 'person',
  primaryDepartmentName: 'primaryDepartmentName',
  placeName: 'placeName',
  holdBaseCertificationName: 'holdBaseCertificationName',
  holdSpecialtyCertificationName: 'holdSpecialtyCertificationName',
  holdHandlingCertificationName: 'holdHandlingCertificationName',
} as const;

export type PeopleCertificationTableColumns =
  (typeof PeopleCertificationTableColumns)[keyof typeof PeopleCertificationTableColumns];

/**
 * 資格種別
 */
export const WorkerTypeWithAll = {
  ...WorkerType,
  ALL: 'ALL',
} as const;

export type WorkerTypeWithAll =
  (typeof WorkerTypeWithAll)[keyof typeof WorkerTypeWithAll];
